const footer = {
  footer: {
    imageTitle: 'Visita il sito Web di Enphase Energy',
    privacy: 'Privacy',
    terms: 'Termini',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. Tutti i diritti riservati.',
    language: 'Lingua',
    production_ct: {
      verify_ct: "Verificare i TA",
      checlist_nodata: "I dati del contatore non sono sufficienti per eseguire questo controllo",
      production_meter_verification: "Verifica contatore di produzione",
      serial_no: "Numero di serie",
      polarity_check: "Verifica polarità",
      polarity_check_failed: "Controllo della polarità fallito",
      ct_missing_branch_check: "Si sta verificando se il CT ha circuiti di derivazione mancanti",
      polarity_check_passed: "Verifica polarità superata",
      ct_no_missing_branch_circuit: "Il CT non ha circuiti di derivazione mancanti",
      incorrect_direction_or_phase_message: "La direzione o la fase del CT di produzione potrebbero essere errate",
      hide_details: "Nascondi dettagli",
      check_try_again: "Verificare quanto segue e riprovare",
      pv_on_for_5_min: "Assicurarsi che il circuito PV sia acceso e che sia accesso da almeno 5 minuti",
      l1_wires_production_ct_message: "Verificare che solo i fili L1 attraversino il CT di produzione e che il flusso di produzione sia nella direzione della freccia CT, dal PV all'interruttore",
      blue_white_wires_position_message: "Assicurarsi che i fili blu e bianco siano collegati nelle posizioni corrette nella morsettiera Gateway",
      wires_include_pv_generation_not_load_storage: "Assicurarsi che i cavi che percorrono il CT di produzione includano solo i circuiti di generazione PV (non quelli di carico o accumulo)",
      l1_a_correct_phase_message: "Assicurarsi che il CT di produzione sia attraversato dalla fase corretta, ossia L1(a).​",
      l1_phase_consistency_check_message: "Verificare la coerenza della fase L1 usando un misuratore digitale e assicurarsi che L1 dei circuiti PV e L1 su Gateway siano nella stessa fase",
      missing_branch_warning: "Il CT di produzione potrebbe avere dei circuiti di derivazione mancanti",
      test_only_valid_for_sunshine_hours: "Questo test è valido solo per le ore di luce del sole",
      reading_lower_than_expected: "Le letture della produzione sono inferiori a quelle previste. Controllare quanto segue, quindi toccare e riprovare",
      wires_include_all_pv_generation: "Assicurarsi che il cavo che percorre il CT di produzione includa tutti i circuiti di generazione PV",
      branch_circuit_reverse_check: "Assicurarsi che nessun circuito derivato attraversi il CT al contrario",
      storage_load_circuits_through_production_ct: "Assicurarsi che il CT di produzione sia attraversato da circuito di accumulo o di carico",
      show_details: "Mostra dettagli",
      verify_ct_not_supported_for_device: "Verificare i TA non è supportata da questo dispositivo",
      verify_ct_timeStamp: "Controllato su",
      verify_ct_systemID: "identificativo del sistema",
      prodct_reversepolarity_text: "La direzione o la fase del CT di produzione potrebbero essere errate",
      prodct_reverse_polarity_btn: "Inversione di polarità",
      verify_ct_timeout: "La richiesta è scaduta. Riprovare"
    }
  }
};

export default footer;
